<script>
import options from "./ContactStepCategoryContent.options"
export default options
</script>

<template>
    <article class="nyk-signup-step nyk-contact-step-category-content">
        <div aria-live="polite" class="nyk-signup-step__content">
            <div class="nyk-signup-step__content__section--66-width nyk-signup-step__content__section--full-width-mobile">
                <div class="nyk-signup-step__header">
                    <h2 class="nyk-signup-step__title">{{ currentStepTexts.title }}</h2>
                    <p class="nyk-signup-step__stepcounter">Step {{ stepCounterText }}</p>
                </div>
            </div>

            <div class="nyk-signup-step__content__section--33-width nyk-signup-step__summary" v-html="currentStepTexts.summary"></div>

            <div class="nyk-signup-step__content__choices nyk-signup-step__content__section--66-width nyk-signup-step__content__section--full-width-mobile">
                <div class="nyk-signup-step__content__choice">
                    <p class="nyk-signup-step__content__choice__question">
                        {{ labels[titleLabelKey] }}
                    </p>
                    <div class="nyk-signup-step__content__choice__inputs">
                        <div class="nyk-signup-step__radio"
                             v-for="category in categories"
                             :key="category.id">
                            <input type="radio"
                                   :name="fieldName"
                                   :id="`${fieldName}-${category.category}`"
                                   :value="category.category"
                                   class="nyk-signup-step__radio__input"
                                   v-model="categoryInput" />
                            <span class="nyk-signup-step__radio__checkmark"></span>
                            <label class="nyk-signup-step__radio__label" :for="`${fieldName}-${category.category}`">{{ category.displayname }}</label>
                        </div>
                    </div>
                </div>

                <p class="nyk-signup-step__content__section--full-width nyk-signup-step__input-error-msg">
                    <template v-if="displayInputError && showFieldErrorMessage(fieldName)">
                        {{ labels[errorLabelKey] ?? 'Besvar venligst ovenstående spørgsmål' }}
                    </template>
                </p>
            </div>

            <div class="nyk-signup-step__summary nyk-signup-step__summary--mobile" v-html="currentStepTexts.summary"></div>

            <div class="nyk-signup-step__mt-auto nyk-signup-step__content__section--full-width">
                <SignupStepActions :previousStepCallback="previousStepCallback"
                                   :nextStepCallback="
                                   ()=>
                    nextStepCallback([
                    { field: fieldName, value: categoryInput },
                    ])
                    "
                    :nextStepButtonText="currentStepTexts.next"
                    :stepCounterText="stepCounterText"
                    :hasPreviousStep="hasPreviousStep" />
            </div>
        </div>
        <div v-if="labels.disclaimerText" class="nyk-signup-step__disclaimer-text">
            <small v-html="labels.disclaimerText"></small>
        </div>
    </article>
</template>
